const CartTotal = ({ total }) => {
	return (
		<div className="flex justify-center items-center text-center">
			<div className="text-xl font-semibold">
				<p>Total Price</p>
				<p className="text-5xl">{total}</p>
			</div>
		</div>
	);
};

export default CartTotal;
